// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.
import expensePayments from './expense-payments.js';

export default [
    {
        path: '/:organisation/payables/expenses',
        component: () =>
            import('@/pages/[organisation]/payables/expenses.vue'),
        name: 'accounts-payable.expenses.search-expenses',
        meta: {
            loginRequired: true,
            permission: 'access.payables.expense.view-expenses',
        },
        children: [
            {
                path: 'create-expense',
                component: () =>
                    import('@/pages/[organisation]/payables/expenses/create-expense.vue'),
                name: 'accounts-payable.expenses.create-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.expense.create-draft-expense',
                },
            },
            {
                path: 'quick-expense',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.expenses" */ '@/pages/[organisation]/payables/expenses/quick-expense.vue'),
                name: 'accounts-payable.expenses.quick-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.expense.create-draft-expense',
                },
            },
            {
                path: ':id',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.expenses" */ '@/pages/[organisation]/payables/expenses/expense/[id].vue'),
                name: 'accounts-payable.expenses.view-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.expense.view-expenses',
                },
                children: [
                    {
                        path: 'new-expense-payment',
                        component: () =>
                            import(/* webpackChunkName: "accounts-payable.expense-payments" */ '@/pages/[organisation]/payables/expense-payments/expense-payment/new.vue'),
                        name: 'accounts-payable.expense-payments.create-expense-payment',
                        meta: {
                            loginRequired: true,
                            permission: 'access.payables.expense-payment.create-expense-payment',
                        },
                    },
                ],
            },
            {
                path: ':id/history',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.expenses" */ '@/pages/[organisation]/payables/expenses/expense-history.vue'),
                name: 'accounts-payable.expenses.view-expense-history',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.expense.view-expenses',
                },
            },
            {
                path: ':id/edit-draft',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.expenses" */ '@/pages/[organisation]/payables/expenses/draft-expense/[id]/edit.vue'),
                name: 'accounts-payable.expenses.update-draft-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.expense.update-expense',
                },
            },
            {
                path: ':id/edit',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.expenses" */ '@/pages/[organisation]/payables/expenses/expense/[id]/edit.vue'),
                name: 'accounts-payable.expenses.update-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.expense.update-expense',
                },
            },
            {
                path: ':id/duplicate',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.expenses" */ '@/pages/[organisation]/payables/expenses/duplicate-expense.vue'),
                name: 'accounts-payable.expenses.duplicate-expense',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.expense.update-expense',
                },
            },
            ...expensePayments,
            {
                path: ':id/create-credit-memo',
                component: () =>
                    import(/* webpackChunkName: "accounts-payable.purchases-credit-memos" */ '@/pages/[organisation]/payables/purchases-credit-memos/purchases-credit-memo/new.vue'),
                name: 'accounts-payable.purchases-credit-memos.create-purchases-credit-memo',
                meta: {
                    loginRequired: true,
                    permission: 'access.payables.purchases-credit-memo.create-purchases-credit-memo',
                },
            },
            // {
            //     path: 'create-expense-spreadsheet',
            //     component: () =>
            //         import(
            //             /* webpackChunkName: "accounts-payable.expenses" */
            //             '@/app/accounts-payable/expenses/views/CreateExpenseSpreadsheet.vue'
            //         ),
            //     name: 'accounts-payable.expenses.create-expense-spreadsheet',
            //     meta: {
            //         loginRequired: true,
            //         permission: 'access.payables.expense.create-draft-expense',
            //     },
            // }
        ],
    },
];
